// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"UXSBG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameters", function() {
    return parameters;
});
parcelHelpers.export(exports, "decorators", function() {
    return decorators;
});
var _addonActions = require("@storybook/addon-actions");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _provider = require("./custom-addons/provider");
var _scrolling = require("./custom-addons/scrolling");
var _strictmode = require("./custom-addons/strictmode");
// decorator order matters, the last one will be the outer most
(0, _addonActions.configureActions)({
    depth: 10
});
var parameters = {
    options: {
        storySort: function(a, b) {
            return a.title === b.title ? 0 : a.id.localeCompare(b.id, undefined, {
                numeric: true
            });
        }
    },
    a11y: {
        config: {
            rules: [
                {
                    id: "aria-hidden-focus",
                    selector: 'body *:not([data-a11y-ignore="aria-hidden-focus"])'
                }
            ]
        }
    },
    layout: "fullscreen",
    // Stops infinite loop memory crash when saving CSF stories https://github.com/storybookjs/storybook/issues/12747#issuecomment-1151803506
    docs: {
        source: {
            type: "code"
        }
    }
};
var decorators = [
    (0, _scrolling.withScrollingSwitcher),
    (0, _provider.withProviderSwitcher)
];

},{"@storybook/addon-actions":"bzvXU","react":"lbBKc","./custom-addons/provider":"4HssR","./custom-addons/scrolling":"iMsrl","./custom-addons/strictmode":"h8F8o","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bzvXU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDON_ID", function() {
    return 0, _chunkWFFRPTHAMjs.ADDON_ID;
});
parcelHelpers.export(exports, "CLEAR_ID", function() {
    return 0, _chunkWFFRPTHAMjs.CLEAR_ID;
});
parcelHelpers.export(exports, "CYCLIC_KEY", function() {
    return 0, _chunkWFFRPTHAMjs.CYCLIC_KEY;
});
parcelHelpers.export(exports, "EVENT_ID", function() {
    return 0, _chunkWFFRPTHAMjs.EVENT_ID;
});
parcelHelpers.export(exports, "PANEL_ID", function() {
    return 0, _chunkWFFRPTHAMjs.PANEL_ID;
});
parcelHelpers.export(exports, "PARAM_KEY", function() {
    return 0, _chunkWFFRPTHAMjs.PARAM_KEY;
});
parcelHelpers.export(exports, "action", function() {
    return 0, _chunkWFFRPTHAMjs.action;
});
parcelHelpers.export(exports, "actions", function() {
    return 0, _chunkWFFRPTHAMjs.actions;
});
parcelHelpers.export(exports, "config", function() {
    return 0, _chunkWFFRPTHAMjs.config;
});
parcelHelpers.export(exports, "configureActions", function() {
    return 0, _chunkWFFRPTHAMjs.configureActions;
});
var _chunkWFFRPTHAMjs = require("./chunk-WFFRPTHA.mjs");

},{"./chunk-WFFRPTHA.mjs":"iOjAX","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"iOjAX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ADDON_ID", function() {
    return ADDON_ID;
});
parcelHelpers.export(exports, "CLEAR_ID", function() {
    return CLEAR_ID;
});
parcelHelpers.export(exports, "CYCLIC_KEY", function() {
    return CYCLIC_KEY;
});
parcelHelpers.export(exports, "EVENT_ID", function() {
    return EVENT_ID;
});
parcelHelpers.export(exports, "PANEL_ID", function() {
    return PANEL_ID;
});
parcelHelpers.export(exports, "PARAM_KEY", function() {
    return PARAM_KEY;
});
parcelHelpers.export(exports, "action", function() {
    return action;
});
parcelHelpers.export(exports, "actions", function() {
    return actions;
});
parcelHelpers.export(exports, "config", function() {
    return config;
});
parcelHelpers.export(exports, "configureActions", function() {
    return configureActions;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _uuid = require("uuid");
var _previewApi = require("@storybook/preview-api");
var _global = require("@storybook/global");
var _previewErrors = require("@storybook/core-events/preview-errors");
var PARAM_KEY = "actions", ADDON_ID = "storybook/actions", PANEL_ID = "".concat(ADDON_ID, "/panel"), EVENT_ID = "".concat(ADDON_ID, "/action-event"), CLEAR_ID = "".concat(ADDON_ID, "/action-clear"), CYCLIC_KEY = "$___storybook.isCyclic";
var config = {
    depth: 10,
    clearOnStoryChange: !0,
    limit: 50
}, configureActions = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Object.assign(config, options);
};
var findProto = function(obj, callback) {
    var proto = Object.getPrototypeOf(obj);
    return !proto || callback(proto) ? proto : findProto(proto, callback);
}, isReactSyntheticEvent = function(e) {
    return !!(typeof e == "object" && e && findProto(e, function(proto) {
        return /^Synthetic(?:Base)?Event$/.test(proto.constructor.name);
    }) && typeof e.persist == "function");
}, serializeArg = function(a) {
    if (isReactSyntheticEvent(a)) {
        var e = Object.create(a.constructor.prototype, Object.getOwnPropertyDescriptors(a));
        e.persist();
        var viewDescriptor = Object.getOwnPropertyDescriptor(e, "view"), view = viewDescriptor === null || viewDescriptor === void 0 ? void 0 : viewDescriptor.value;
        return typeof view == "object" && (view === null || view === void 0 ? void 0 : view.constructor.name) === "Window" && Object.defineProperty(e, "view", (0, _objectSpreadProps._)((0, _objectSpread._)({}, viewDescriptor), {
            value: Object.create(view.constructor.prototype)
        })), e;
    }
    return a;
}, generateId = function() {
    return typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? (0, _uuid.v4)() : Date.now().toString(36) + Math.random().toString(36).substring(2);
};
function action(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var actionOptions = (0, _objectSpread._)({}, config, options), handler = function handler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (options.implicit) {
            var _this;
            var storyRenderer = (_this = "__STORYBOOK_PREVIEW__" in (0, _global.global) ? (0, _global.global).__STORYBOOK_PREVIEW__ : void 0) === null || _this === void 0 ? void 0 : _this.storyRenders.find(function(render) {
                return render.phase === "playing" || render.phase === "rendering";
            });
            if (storyRenderer) {
                var _window_FEATURES, _window;
                var deprecated = !((_window = window) === null || _window === void 0 ? void 0 : (_window_FEATURES = _window.FEATURES) === null || _window_FEATURES === void 0 ? void 0 : _window_FEATURES.disallowImplicitActionsInRenderV8), error = new (0, _previewErrors.ImplicitActionsDuringRendering)({
                    phase: storyRenderer.phase,
                    name: name,
                    deprecated: deprecated
                });
                if (deprecated) console.warn(error);
                else throw error;
            }
        }
        var channel = (0, _previewApi.addons).getChannel(), id = generateId(), minDepth = 5, serializedArgs = args.map(serializeArg), normalizedArgs = args.length > 1 ? serializedArgs : serializedArgs[0], actionDisplayToEmit = {
            id: id,
            count: 0,
            data: {
                name: name,
                args: normalizedArgs
            },
            options: (0, _objectSpreadProps._)((0, _objectSpread._)({}, actionOptions), {
                maxDepth: minDepth + (actionOptions.depth || 3),
                allowFunction: actionOptions.allowFunction || !1
            })
        };
        channel.emit(EVENT_ID, actionDisplayToEmit);
    };
    return handler.isAction = !0, handler;
}
var actions = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var options = config, names = args;
    var ref;
    names.length === 1 && Array.isArray(names[0]) && (ref = (0, _slicedToArray._)(names, 1), names = ref[0], ref), names.length !== 1 && typeof names[names.length - 1] != "string" && (options = (0, _objectSpread._)({}, config, names.pop()));
    var namesObject = names[0];
    (names.length !== 1 || typeof namesObject == "string") && (namesObject = {}, names.forEach(function(name) {
        namesObject[name] = name;
    }));
    var actionsObject = {};
    return Object.keys(namesObject).forEach(function(name) {
        actionsObject[name] = action(namesObject[name], options);
    }), actionsObject;
};

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_sliced_to_array":"jzEiA","uuid":"23yP7","@storybook/preview-api":"3zhcF","@storybook/global":"i6gHT","@storybook/core-events/preview-errors":"ktqKb","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"23yP7":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":false,"./v3.js":false,"./v4.js":"gd237","./v5.js":false,"./nil.js":false,"./version.js":false,"./validate.js":false,"./stringify.js":false,"./parse.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"gd237":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"6Vt90","./rng.js":"6dk3H","./stringify.js":"89Dto","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6Vt90":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID: randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"6dk3H":[function(require,module,exports) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"89Dto":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", function() {
    return unsafeStringify;
});
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"buQwZ","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"buQwZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === "string" && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"71yoU","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"71yoU":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"lbBKc":[function(require,module,exports) {
"use strict";
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"4T9ze"}],"4T9ze":[function(require,module,exports) {
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var _typeOf = require("@swc/helpers/_/_type_of");
"use strict";
var l = require("f790cf940e488cc5"), n = "function" === typeof Symbol && Symbol.for, p = n ? Symbol.for("react.element") : 60103, q = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, t = n ? Symbol.for("react.strict_mode") : 60108, u = n ? Symbol.for("react.profiler") : 60114, v = n ? Symbol.for("react.provider") : 60109, w = n ? Symbol.for("react.context") : 60110, x = n ? Symbol.for("react.forward_ref") : 60112, y = n ? Symbol.for("react.suspense") : 60113, z = n ? Symbol.for("react.memo") : 60115, A = n ? Symbol.for("react.lazy") : 60116, B = "function" === typeof Symbol && Symbol.iterator;
function C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var D = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, E = {};
function F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = E;
    this.updater = c || D;
}
F.prototype.isReactComponent = {};
F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function G() {}
G.prototype = F.prototype;
function H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = E;
    this.updater = c || D;
}
var I = H.prototype = new G;
I.constructor = H;
l(I, F.prototype);
I.isPureReactComponent = !0;
var J = {
    current: null
}, K = Object.prototype.hasOwnProperty, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)K.call(b, e) && !L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: J.current
    };
}
function N(a, b) {
    return {
        $$typeof: p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === p;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g, Q = [];
function R(a, b, c, e) {
    if (Q.length) {
        var d = Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > Q.length && Q.push(a);
}
function T(a, b, c, e) {
    var d = typeof a === "undefined" ? "undefined" : (0, _typeOf._)(a);
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case p:
                case q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + U(d, k);
        g += T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + U(d, k++), g += T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error(C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function V(a, b, c) {
    return null == a ? 0 : T(a, "", b, c);
}
function U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}
function W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? X(a, e, c, function(a) {
        return a;
    }) : null != a && (O(a) && (a = N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(P, "$&/") + "/") + c)), e.push(a));
}
function X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace(P, "$&/") + "/");
    b = R(b, g, e, d);
    V(a, aa, b);
    S(b);
}
var Y = {
    current: null
};
function Z() {
    var a = Y.current;
    if (null === a) throw Error(C(321));
    return a;
}
var ba = {
    ReactCurrentDispatcher: Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: l
};
exports.Children = {
    map: function map(a, b, c) {
        if (null == a) return a;
        var e = [];
        X(a, e, null, b, c);
        return e;
    },
    forEach: function forEach(a, b, c) {
        if (null == a) return a;
        b = R(null, null, b, c);
        V(a, W, b);
        S(b);
    },
    count: function count(a) {
        return V(a, function() {
            return null;
        }, null);
    },
    toArray: function toArray(a) {
        var b = [];
        X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function only(a) {
        if (!O(a)) throw Error(C(143));
        return a;
    }
};
exports.Component = F;
exports.Fragment = r;
exports.Profiler = u;
exports.PureComponent = H;
exports.StrictMode = t;
exports.Suspense = y;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ba;
exports.cloneElement = function(a, b, c) {
    if (null === a || void 0 === a) throw Error(C(267, a));
    var e = l({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)K.call(b, h) && !L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
exports.createContext = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: v,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: x,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.useCallback = function(a, b) {
    return Z().useCallback(a, b);
};
exports.useContext = function(a, b) {
    return Z().useContext(a, b);
};
exports.useDebugValue = function() {};
exports.useEffect = function(a, b) {
    return Z().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
    return Z().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
    return Z().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return Z().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
    return Z().useReducer(a, b, c);
};
exports.useRef = function(a) {
    return Z().useRef(a);
};
exports.useState = function(a) {
    return Z().useState(a);
};
exports.version = "16.14.0";

},{"@swc/helpers/_/_type_of":"cHZd3","f790cf940e488cc5":"iYiar"}],"iYiar":[function(require,module,exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"4HssR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withProviderSwitcher", function() {
    return withProviderSwitcher;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _previewApi = require("@storybook/preview-api");
var _provider = require("@react-spectrum/provider");
var _constants = require("../../constants");
document.body.style.margin = "0";
var providerValuesFromUrl = Object.entries((0, _previewApi.getQueryParams)()).reduce(function(acc, param) {
    var _param = (0, _slicedToArray._)(param, 2), k = _param[0], v = _param[1];
    if (k.includes("providerSwitcher-")) return (0, _objectSpreadProps._)((0, _objectSpread._)({}, acc), (0, _defineProperty._)({}, k.replace("providerSwitcher-", ""), v));
    return acc;
}, {});
function ProviderUpdater(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(providerValuesFromUrl.locale || undefined), 2), localeValue = _useState[0], setLocale = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(providerValuesFromUrl.theme || undefined), 2), themeValue = _useState1[0], setTheme = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(providerValuesFromUrl.scale || undefined), 2), scaleValue = _useState2[0], setScale = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(providerValuesFromUrl.express === "true"), 2), expressValue = _useState3[0], setExpress = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(window.parent === window || window.parent !== window.top), 2), storyReady = _useState4[0], setStoryReady = _useState4[1]; // reduce content flash because it takes a moment to get the provider details
    // Typically themes are provided with both light + dark, and both scales.
    // To build our selector to see all themes, we need to hack it a bit.
    var theme = (expressValue ? (0, _constants.expressThemes) : (0, _constants.themes))[themeValue || "light"] || (0, _constants.defaultTheme);
    var colorScheme = themeValue && themeValue.replace(/est$/, "");
    (0, _react.useEffect)(function() {
        var channel = (0, _previewApi.addons).getChannel();
        var providerUpdate = function(event) {
            setLocale(event.locale);
            setTheme(event.theme === "Auto" ? undefined : event.theme);
            setScale(event.scale === "Auto" ? undefined : event.scale);
            setExpress(event.express);
            setStoryReady(true);
        };
        channel.on("provider/updated", providerUpdate);
        channel.emit("rsp/ready-for-update");
        return function() {
            channel.removeListener("provider/updated", providerUpdate);
        };
    }, []);
    if (props.options.mainElement == null) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        theme: theme,
        colorScheme: colorScheme,
        scale: scaleValue,
        locale: localeValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("main", null, storyReady && props.children));
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _provider.Provider), {
        theme: theme,
        colorScheme: colorScheme,
        scale: scaleValue,
        locale: localeValue
    }, storyReady && props.children);
}
var withProviderSwitcher = (0, _previewApi.makeDecorator)({
    name: "withProviderSwitcher",
    parameterName: "providerSwitcher",
    wrapper: function(getStory, context, param) {
        var options = param.options, parameters = param.parameters;
        options = (0, _objectSpread._)({}, options, parameters);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(ProviderUpdater, {
            options: options,
            context: context
        }, getStory(context));
    }
});

},{"@swc/helpers/_/_define_property":"5nkYf","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_sliced_to_array":"jzEiA","react":"lbBKc","@storybook/preview-api":"3zhcF","@react-spectrum/provider":"5OFwq","../../constants":"7YtDa","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"5OFwq":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return 0, _provider.Provider;
});
parcelHelpers.export(exports, "useProvider", function() {
    return 0, _provider.useProvider;
});
parcelHelpers.export(exports, "useProviderProps", function() {
    return 0, _provider.useProviderProps;
});
var _provider = require("./Provider");

},{"./Provider":"1gi14","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"1gi14":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return _Provider;
});
/**
 * Returns the various settings and styles applied by the nearest parent Provider.
 * Properties explicitly set by the nearest parent Provider override those provided by preceeding Providers.
 */ parcelHelpers.export(exports, "useProvider", function() {
    return useProvider;
});
parcelHelpers.export(exports, "useProviderProps", function() {
    return useProviderProps;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@react-spectrum/utils");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _context = require("./context");
var _utils1 = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _overlays = require("@react-aria/overlays");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _varsCss = require("@adobe/spectrum-css-temp/components/page/vars.css");
var _varsCssDefault = parcelHelpers.interopDefault(_varsCss);
var _indexCss = require("@adobe/spectrum-css-temp/components/typography/index.css");
var _indexCssDefault = parcelHelpers.interopDefault(_indexCss);
var _mediaQueries = require("./mediaQueries");
// @ts-ignore
var _packageJson = require("../package.json");
var DEFAULT_BREAKPOINTS = {
    S: 640,
    M: 768,
    L: 1024,
    XL: 1280,
    XXL: 1536
};
function Provider(props, ref) {
    var prevContext = useProvider();
    var prevColorScheme = prevContext && prevContext.colorScheme;
    var prevBreakpoints = prevContext && prevContext.breakpoints;
    var _props_theme = props.theme, theme = _props_theme === void 0 ? prevContext && prevContext.theme : _props_theme, defaultColorScheme = props.defaultColorScheme;
    if (!theme) throw new Error("theme not found, the parent provider must have a theme provided");
    // Hooks must always be called.
    var autoColorScheme = (0, _mediaQueries.useColorScheme)(theme, defaultColorScheme);
    var autoScale = (0, _mediaQueries.useScale)(theme);
    var _useLocale = (0, _i18N.useLocale)(), prevLocale = _useLocale.locale;
    // if the new theme doesn't support the prevColorScheme, we must resort to the auto
    var usePrevColorScheme = !!theme[prevColorScheme];
    // importance of color scheme props > parent > auto:(OS > default > omitted)
    var _props_colorScheme = props.colorScheme, colorScheme = _props_colorScheme === void 0 ? usePrevColorScheme ? prevColorScheme : autoColorScheme : _props_colorScheme, _props_scale = props.scale, scale = _props_scale === void 0 ? prevContext ? prevContext.scale : autoScale : _props_scale, _props_locale = props.locale, locale = _props_locale === void 0 ? prevContext ? prevLocale : null : _props_locale, _props_breakpoints = props.breakpoints, breakpoints = _props_breakpoints === void 0 ? prevContext ? prevBreakpoints : DEFAULT_BREAKPOINTS : _props_breakpoints, children = props.children, isQuiet = props.isQuiet, isEmphasized = props.isEmphasized, isDisabled = props.isDisabled, isRequired = props.isRequired, isReadOnly = props.isReadOnly, validationState = props.validationState, router = props.router, otherProps = (0, _objectWithoutProperties._)(props, [
        "colorScheme",
        "scale",
        "locale",
        "breakpoints",
        "children",
        "isQuiet",
        "isEmphasized",
        "isDisabled",
        "isRequired",
        "isReadOnly",
        "validationState",
        "router"
    ]);
    // select only the props with values so undefined props don't overwrite prevContext values
    var currentProps = {
        version: (0, _packageJson.version),
        theme: theme,
        breakpoints: breakpoints,
        colorScheme: colorScheme,
        scale: scale,
        isQuiet: isQuiet,
        isEmphasized: isEmphasized,
        isDisabled: isDisabled,
        isRequired: isRequired,
        isReadOnly: isReadOnly,
        validationState: validationState
    };
    var matchedBreakpoints = (0, _utils.useMatchedBreakpoints)(breakpoints);
    var filteredProps = {};
    Object.entries(currentProps).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        return value !== undefined && (filteredProps[key] = value);
    });
    // Merge options with parent provider
    var context = Object.assign({}, prevContext, filteredProps);
    // Only wrap in a DOM node if the theme, colorScheme, or scale changed
    var contents = children;
    var domProps = (0, _utils1.filterDOMProps)(otherProps);
    var styleProps = (0, _utils.useStyleProps)(otherProps, undefined, {
        matchedBreakpoints: matchedBreakpoints
    }).styleProps;
    if (!prevContext || props.locale || theme !== prevContext.theme || colorScheme !== prevContext.colorScheme || scale !== prevContext.scale || Object.keys(domProps).length > 0 || otherProps.UNSAFE_className || Object.keys(styleProps.style).length > 0) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(ProviderWrapper, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        UNSAFE_style: (0, _objectSpread._)({
            isolation: !prevContext ? "isolate" : undefined
        }, styleProps.style),
        ref: ref
    }), contents);
    if (router) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils1.RouterProvider), router, contents);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.Context).Provider, {
        value: context
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _i18N.I18nProvider), {
        locale: locale
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.BreakpointProvider), {
        matchedBreakpoints: matchedBreakpoints
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlays.ModalProvider), null, contents))));
}
/**
 * Provider is the container for all React Spectrum applications.
 * It defines the theme, locale, and other application level settings,
 * and can also be used to provide common properties to a group of components.
 */ var _Provider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(Provider);
var ProviderWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function ProviderWrapper(props, ref) {
    var children = props.children, otherProps = (0, _objectWithoutProperties._)(props, [
        "children"
    ]);
    var _useLocale = (0, _i18N.useLocale)(), locale = _useLocale.locale, direction = _useLocale.direction;
    var _useProvider = useProvider(), theme = _useProvider.theme, colorScheme = _useProvider.colorScheme, scale = _useProvider.scale;
    var modalProviderProps = (0, _overlays.useModalProvider)().modalProviderProps;
    var styleProps = (0, _utils.useStyleProps)(otherProps).styleProps;
    var domRef = (0, _utils.useDOMRef)(ref);
    var themeKey = Object.keys(theme[colorScheme])[0];
    var scaleKey = Object.keys(theme[scale])[0];
    var _obj;
    var className = (0, _clsxDefault.default)(styleProps.className, (0, _varsCssDefault.default)["spectrum"], (0, _indexCssDefault.default)["spectrum"], Object.values(theme[colorScheme]), Object.values(theme[scale]), theme.global ? Object.values(theme.global) : null, (_obj = {
        "react-spectrum-provider": (0, _utils.shouldKeepSpectrumClassNames),
        spectrum: (0, _utils.shouldKeepSpectrumClassNames)
    }, (0, _defineProperty._)(_obj, themeKey, (0, _utils.shouldKeepSpectrumClassNames)), (0, _defineProperty._)(_obj, scaleKey, (0, _utils.shouldKeepSpectrumClassNames)), _obj));
    var _props_colorScheme, _ref;
    var style = (0, _objectSpreadProps._)((0, _objectSpread._)({}, styleProps.style), {
        // This ensures that browser native UI like scrollbars are rendered in the right color scheme.
        // See https://web.dev/color-scheme/.
        colorScheme: (_ref = (_props_colorScheme = props.colorScheme) !== null && _props_colorScheme !== void 0 ? _props_colorScheme : colorScheme) !== null && _ref !== void 0 ? _ref : Object.keys(theme).filter(function(k) {
            return k === "light" || k === "dark";
        }).join(" ")
    });
    var hasWarned = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        if (direction && domRef.current) {
            var closestDir = domRef.current.parentElement.closest("[dir]");
            var dir = closestDir && closestDir.getAttribute("dir");
            if (dir && dir !== direction && !hasWarned.current) {
                console.warn("Language directions cannot be nested. ".concat(direction, " inside ").concat(dir, "."));
                hasWarned.current = true;
            }
        }
    }, [
        direction,
        domRef,
        hasWarned
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _utils1.filterDOMProps)(otherProps), styleProps, modalProviderProps), {
        className: className,
        style: style,
        lang: locale,
        dir: direction,
        ref: domRef
    }), children);
});
function useProvider() {
    return (0, _react.useContext)((0, _context.Context));
}
function useProviderProps(props) {
    var context = useProvider();
    if (!context) return props;
    return Object.assign({}, {
        isQuiet: context.isQuiet,
        isEmphasized: context.isEmphasized,
        isDisabled: context.isDisabled,
        isRequired: context.isRequired,
        isReadOnly: context.isReadOnly,
        validationState: context.validationState
    }, props);
}

},{"@swc/helpers/_/_define_property":"5nkYf","@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","@swc/helpers/_/_sliced_to_array":"jzEiA","@react-spectrum/utils":"aBh9y","clsx":"CejKb","./context":"bFgY8","@react-aria/utils":"g2eof","@react-aria/i18n":"3B1HT","@react-aria/overlays":"3jnmZ","react":"lbBKc","@adobe/spectrum-css-temp/components/page/vars.css":"kvhvT","@adobe/spectrum-css-temp/components/typography/index.css":"6rZzn","./mediaQueries":"224cU","../package.json":"3lp0l","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"bFgY8":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", function() {
    return Context;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var Context = (0, _reactDefault.default).createContext(null);
Context.displayName = "ProviderContext";

},{"react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"kvhvT":[function(require,module,exports) {
module.exports["focus-ring"] = "JuTe6q_focus-ring";
module.exports["i18nFontFamily"] = "JuTe6q_i18nFontFamily";
module.exports["spectrum"] = "JuTe6q_spectrum";
module.exports["spectrum-FocusRing-ring"] = "JuTe6q_spectrum-FocusRing-ring";
module.exports["spectrum-FocusRing"] = "JuTe6q_spectrum-FocusRing ".concat(module.exports["spectrum-FocusRing-ring"]);
module.exports["spectrum-FocusRing--quiet"] = "JuTe6q_spectrum-FocusRing--quiet";

},{}],"6rZzn":[function(require,module,exports) {
module.exports["focus-ring"] = "_5QszkG_focus-ring";
module.exports["i18nFontFamily"] = "_5QszkG_i18nFontFamily";
module.exports["spectrum"] = "_5QszkG_spectrum ".concat(module.exports["i18nFontFamily"]);
module.exports["spectrum-Body"] = "_5QszkG_spectrum-Body";
module.exports["spectrum-Body--italic"] = "_5QszkG_spectrum-Body--italic";
module.exports["spectrum-FocusRing-ring"] = "_5QszkG_spectrum-FocusRing-ring";
module.exports["spectrum-FocusRing"] = "_5QszkG_spectrum-FocusRing ".concat(module.exports["spectrum-FocusRing-ring"]);
module.exports["spectrum-FocusRing--quiet"] = "_5QszkG_spectrum-FocusRing--quiet";

},{}],"224cU":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useColorScheme", function() {
    return useColorScheme;
});
parcelHelpers.export(exports, "useScale", function() {
    return useScale;
});
var _utils = require("@react-spectrum/utils");
function useColorScheme(theme, defaultColorScheme) {
    var matchesDark = (0, _utils.useMediaQuery)("(prefers-color-scheme: dark)");
    var matchesLight = (0, _utils.useMediaQuery)("(prefers-color-scheme: light)");
    // importance OS > default > omitted
    if (theme.dark && matchesDark) return "dark";
    if (theme.light && matchesLight) return "light";
    if (theme.dark && defaultColorScheme === "dark") return "dark";
    if (theme.light && defaultColorScheme === "light") return "light";
    if (!theme.dark) return "light";
    if (!theme.light) return "dark";
    return "light";
}
function useScale(theme) {
    var matchesFine = (0, _utils.useMediaQuery)("(any-pointer: fine)");
    if (matchesFine && theme.medium) return "medium";
    if (theme.large) return "large";
    return "medium";
}

},{"@react-spectrum/utils":"aBh9y","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"3lp0l":[function(require,module,exports) {
module.exports = JSON.parse('{"name":"@react-spectrum/provider","version":"3.9.6","description":"Spectrum UI components in React","license":"Apache-2.0","main":"dist/main.js","module":"dist/module.js","exports":{"types":"./dist/types.d.ts","import":"./dist/import.mjs","require":"./dist/main.js"},"types":"dist/types.d.ts","source":"src/index.ts","files":["dist","src"],"sideEffects":["*.css"],"targets":{"main":{"includeNodeModules":["@adobe/spectrum-css-temp"]},"module":{"includeNodeModules":["@adobe/spectrum-css-temp"]}},"repository":{"type":"git","url":"https://github.com/adobe/react-spectrum"},"dependencies":{"@react-aria/i18n":"^3.11.0","@react-aria/overlays":"^3.22.0","@react-aria/utils":"^3.24.0","@react-spectrum/utils":"^3.11.6","@react-types/provider":"^3.8.0","@react-types/shared":"^3.23.0","@swc/helpers":"^0.5.0","clsx":"^2.0.0"},"devDependencies":{"@adobe/spectrum-css-temp":"3.0.0-alpha.1"},"peerDependencies":{"react":"^16.8.0 || ^17.0.0-rc.1 || ^18.0.0","react-dom":"^16.8.0 || ^17.0.0-rc.1 || ^18.0.0"},"publishConfig":{"access":"public"}}');

},{}],"7YtDa":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scales", function() {
    return scales;
});
parcelHelpers.export(exports, "defaultTheme", function() {
    return defaultTheme;
});
parcelHelpers.export(exports, "altTheme", function() {
    return altTheme;
});
parcelHelpers.export(exports, "themes", function() {
    return themes;
});
parcelHelpers.export(exports, "expressThemes", function() {
    return expressThemes;
});
parcelHelpers.export(exports, "locales", function() {
    return locales;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _spectrumGlobalCss = require("@adobe/spectrum-css-temp/vars/spectrum-global.css");
var _spectrumGlobalCssDefault = parcelHelpers.interopDefault(_spectrumGlobalCss);
var _spectrumLightCss = require("@adobe/spectrum-css-temp/vars/spectrum-light.css");
var _spectrumLightCssDefault = parcelHelpers.interopDefault(_spectrumLightCss);
var _spectrumLightestCss = require("@adobe/spectrum-css-temp/vars/spectrum-lightest.css");
var _spectrumLightestCssDefault = parcelHelpers.interopDefault(_spectrumLightestCss);
var _spectrumDarkCss = require("@adobe/spectrum-css-temp/vars/spectrum-dark.css");
var _spectrumDarkCssDefault = parcelHelpers.interopDefault(_spectrumDarkCss);
var _spectrumDarkestCss = require("@adobe/spectrum-css-temp/vars/spectrum-darkest.css");
var _spectrumDarkestCssDefault = parcelHelpers.interopDefault(_spectrumDarkestCss);
var _spectrumMediumCss = require("@adobe/spectrum-css-temp/vars/spectrum-medium.css");
var _spectrumMediumCssDefault = parcelHelpers.interopDefault(_spectrumMediumCss);
var _spectrumLargeCss = require("@adobe/spectrum-css-temp/vars/spectrum-large.css");
var _spectrumLargeCssDefault = parcelHelpers.interopDefault(_spectrumLargeCss);
var _expressCss = require("@adobe/spectrum-css-temp/vars/express.css");
var _expressCssDefault = parcelHelpers.interopDefault(_expressCss);
var THEME = {
    global: (0, _spectrumGlobalCssDefault.default),
    light: (0, _spectrumLightCssDefault.default),
    lightest: (0, _spectrumLightestCssDefault.default),
    dark: (0, _spectrumDarkCssDefault.default),
    darkest: (0, _spectrumDarkestCssDefault.default)
};
var scales = {
    medium: (0, _spectrumMediumCssDefault.default),
    large: (0, _spectrumLargeCssDefault.default)
};
var defaultTheme = {
    global: THEME.global,
    light: THEME.light,
    dark: THEME.darkest,
    medium: scales.medium,
    large: scales.large
};
var altTheme = {
    global: THEME.global,
    light: THEME.lightest,
    dark: THEME.dark,
    medium: scales.medium,
    large: scales.large
};
var themes = {
    light: defaultTheme,
    dark: altTheme,
    lightest: altTheme,
    darkest: defaultTheme
};
var expressThemes = {};
for(var key in themes)expressThemes[key] = (0, _objectSpreadProps._)((0, _objectSpread._)({}, themes[key]), {
    global: (0, _objectSpreadProps._)((0, _objectSpread._)({}, themes[key].global), {
        express: (0, _expressCssDefault.default).express
    }),
    medium: (0, _objectSpreadProps._)((0, _objectSpread._)({}, themes[key].medium), {
        express: (0, _expressCssDefault.default).medium
    }),
    large: (0, _objectSpreadProps._)((0, _objectSpread._)({}, themes[key].large), {
        express: (0, _expressCssDefault.default).large
    })
});
var locales = [
    {
        label: "Auto",
        value: ""
    },
    // Tier 1
    {
        label: "French (France)",
        value: "fr-FR"
    },
    {
        label: "French (Canada)",
        value: "fr-CA"
    },
    {
        label: "German (Germany)",
        value: "de-DE"
    },
    {
        label: "English (Great Britain)",
        value: "en-GB"
    },
    {
        label: "English (United States)",
        value: "en-US"
    },
    {
        label: "Japanese (Japan)",
        value: "ja-JP"
    },
    // // Tier 2
    {
        label: "Danish (Denmark)",
        value: "da-DK"
    },
    {
        label: "Dutch (Netherlands)",
        value: "nl-NL"
    },
    {
        label: "Finnish (Finland)",
        value: "fi-FI"
    },
    {
        label: "Italian (Italy)",
        value: "it-IT"
    },
    {
        label: "Norwegian (Norway)",
        value: "nb-NO"
    },
    {
        label: "Spanish (Spain)",
        value: "es-ES"
    },
    {
        label: "Swedish (Sweden)",
        value: "sv-SE"
    },
    {
        label: "Portuguese (Brazil)",
        value: "pt-BR"
    },
    // // Tier 3
    {
        label: "Chinese (Simplified)",
        value: "zh-CN"
    },
    {
        label: "Chinese (Traditional)",
        value: "zh-TW"
    },
    {
        label: "Korean (Korea)",
        value: "ko-KR"
    },
    // // Tier 4
    {
        label: "Bulgarian (Bulgaria)",
        value: "bg-BG"
    },
    {
        label: "Croatian (Croatia)",
        value: "hr-HR"
    },
    {
        label: "Czech (Czech Republic)",
        value: "cs-CZ"
    },
    {
        label: "Estonian (Estonia)",
        value: "et-EE"
    },
    {
        label: "Hungarian (Hungary)",
        value: "hu-HU"
    },
    {
        label: "Latvian (Latvia)",
        value: "lv-LV"
    },
    {
        label: "Lithuanian (Lithuania)",
        value: "lt-LT"
    },
    {
        label: "Polish (Poland)",
        value: "pl-PL"
    },
    {
        label: "Romanian (Romania)",
        value: "ro-RO"
    },
    {
        label: "Russian (Russia)",
        value: "ru-RU"
    },
    {
        label: "Serbian (Serbia)",
        value: "sr-SP"
    },
    {
        label: "Slovakian (Slovakia)",
        value: "sk-SK"
    },
    {
        label: "Slovenian (Slovenia)",
        value: "sl-SI"
    },
    {
        label: "Turkish (Turkey)",
        value: "tr-TR"
    },
    {
        label: "Ukrainian (Ukraine)",
        value: "uk-UA"
    },
    // // Tier 5
    {
        label: "Arabic (United Arab Emirates)",
        value: "ar-AE"
    },
    {
        label: "Greek (Greece)",
        value: "el-GR"
    },
    {
        label: "Hebrew (Israel)",
        value: "he-IL"
    }
];

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@adobe/spectrum-css-temp/vars/spectrum-global.css":"cH7AN","@adobe/spectrum-css-temp/vars/spectrum-light.css":"7eVIv","@adobe/spectrum-css-temp/vars/spectrum-lightest.css":"9T31Q","@adobe/spectrum-css-temp/vars/spectrum-dark.css":"6z5Wp","@adobe/spectrum-css-temp/vars/spectrum-darkest.css":"7HQPw","@adobe/spectrum-css-temp/vars/spectrum-medium.css":"hfwmN","@adobe/spectrum-css-temp/vars/spectrum-large.css":"gGHXn","@adobe/spectrum-css-temp/vars/express.css":"kO8I9","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"cH7AN":[function(require,module,exports) {
module.exports["spectrum"] = "zA6MfG_spectrum";
module.exports["spectrum--dark"] = "zA6MfG_spectrum--dark";
module.exports["spectrum--darkest"] = "zA6MfG_spectrum--darkest";
module.exports["spectrum--large"] = "zA6MfG_spectrum--large";
module.exports["spectrum--light"] = "zA6MfG_spectrum--light";
module.exports["spectrum--lightest"] = "zA6MfG_spectrum--lightest";
module.exports["spectrum--medium"] = "zA6MfG_spectrum--medium";

},{}],"7eVIv":[function(require,module,exports) {
module.exports["spectrum--light"] = "PFjRbG_spectrum--light";

},{}],"9T31Q":[function(require,module,exports) {
module.exports["spectrum--lightest"] = "NLciOW_spectrum--lightest";

},{}],"6z5Wp":[function(require,module,exports) {
module.exports["spectrum--dark"] = "_1qEKta_spectrum--dark";

},{}],"7HQPw":[function(require,module,exports) {
module.exports["spectrum--darkest"] = "gP7gvq_spectrum--darkest";

},{}],"hfwmN":[function(require,module,exports) {
module.exports["spectrum--medium"] = "xSyFOq_spectrum--medium";

},{}],"gGHXn":[function(require,module,exports) {
module.exports["spectrum--large"] = "HAZavG_spectrum--large";

},{}],"kO8I9":[function(require,module,exports) {
module.exports["express"] = "-9mX2q_express";
module.exports["large"] = "-9mX2q_large";
module.exports["medium"] = "-9mX2q_medium";

},{}],"iMsrl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withScrollingSwitcher", function() {
    return withScrollingSwitcher;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _previewApi = require("@storybook/preview-api");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function ScrollingDecorator(props) {
    var _getQueryParams;
    var children = props.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(((_getQueryParams = (0, _previewApi.getQueryParams)()) === null || _getQueryParams === void 0 ? void 0 : _getQueryParams.scrolling) === "true" || false), 2), isScrolling = _useState[0], setScrolling = _useState[1];
    (0, _react.useEffect)(function() {
        var channel = (0, _previewApi.addons).getChannel();
        var updateScrolling = function(val) {
            setScrolling(val);
        };
        channel.on("scrolling/updated", updateScrolling);
        return function() {
            channel.removeListener("scrolling/updated", updateScrolling);
        };
    }, []);
    var styles = {
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center"
    };
    if (isScrolling) return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        style: {
            overflow: "auto",
            height: "100vh",
            width: "100vw"
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(StoryWrapper, {
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, styles), {
            height: "300vh",
            width: "300vw"
        })
    }, children));
    else return /*#__PURE__*/ (0, _reactDefault.default).createElement(StoryWrapper, {
        style: (0, _objectSpreadProps._)((0, _objectSpread._)({}, styles), {
            minHeight: "100svh"
        })
    }, children);
}
function StoryWrapper(param) {
    var children = param.children, className = param.className, style = param.style;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsxDefault.default)("react-spectrum-story", className),
        style: style
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        style: {
            position: "absolute",
            top: 0,
            left: 0
        }
    }, (0, _reactDefault.default).version), children);
}
var withScrollingSwitcher = function(Story) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(ScrollingDecorator, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(Story, null));
};

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_sliced_to_array":"jzEiA","@storybook/preview-api":"3zhcF","clsx":"CejKb","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"h8F8o":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withStrictModeSwitcher", function() {
    return withStrictModeSwitcher;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _previewApi = require("@storybook/preview-api");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function StrictModeDecorator(props) {
    var _getQueryParams;
    var children = props.children;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(((_getQueryParams = (0, _previewApi.getQueryParams)()) === null || _getQueryParams === void 0 ? void 0 : _getQueryParams.strict) !== "false"), 2), isStrict = _useState[0], setStrict = _useState[1];
    (0, _react.useEffect)(function() {
        var channel = (0, _previewApi.addons).getChannel();
        var updateStrict = function(val) {
            setStrict(val);
        };
        channel.on("strict/updated", updateStrict);
        return function() {
            channel.removeListener("strict/updated", updateStrict);
        };
    }, []);
    return isStrict ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.StrictMode), null, children) : children;
}
var withStrictModeSwitcher = (0, _previewApi.makeDecorator)({
    name: "withStrictModeSwitcher",
    parameterName: "strictModeSwitcher",
    wrapper: function(getStory, context) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(StrictModeDecorator, null, getStory(context));
    }
});

},{"@swc/helpers/_/_sliced_to_array":"jzEiA","@storybook/preview-api":"3zhcF","react":"lbBKc","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"4Ingl":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_class_private_field_init", function() {
    return _class_private_field_init;
});
parcelHelpers.export(exports, "_", function() {
    return _class_private_field_init;
});
var _checkPrivateRedeclarationJs = require("./_check_private_redeclaration.js");
function _class_private_field_init(obj, privateMap, value) {
    (0, _checkPrivateRedeclarationJs._check_private_redeclaration)(obj, privateMap);
    privateMap.set(obj, value);
}

},{"./_check_private_redeclaration.js":"1BZIi","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"1BZIi":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_check_private_redeclaration", function() {
    return _check_private_redeclaration;
});
parcelHelpers.export(exports, "_", function() {
    return _check_private_redeclaration;
});
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"glklC":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisuallyHidden", function() {
    return 0, _visuallyHidden.useVisuallyHidden;
});
parcelHelpers.export(exports, "VisuallyHidden", function() {
    return 0, _visuallyHidden.VisuallyHidden;
});
var _visuallyHidden = require("./VisuallyHidden");

},{"./VisuallyHidden":"heq8x","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}],"heq8x":[function(require,module,exports) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides props for an element that hides its children visually
 * but keeps content visible to assistive technology.
 */ parcelHelpers.export(exports, "useVisuallyHidden", function() {
    return useVisuallyHidden;
});
/**
 * VisuallyHidden hides its children visually, while keeping content visible
 * to screen readers.
 */ parcelHelpers.export(exports, "VisuallyHidden", function() {
    return VisuallyHidden;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@react-aria/utils");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _interactions = require("@react-aria/interactions");
var styles = {
    border: 0,
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap"
};
function useVisuallyHidden() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var style = props.style, isFocusable = props.isFocusable;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isFocused = _useState[0], setFocused = _useState[1];
    var focusWithinProps = (0, _interactions.useFocusWithin)({
        isDisabled: !isFocusable,
        onFocusWithinChange: function(val) {
            return setFocused(val);
        }
    }).focusWithinProps;
    // If focused, don't hide the element.
    var combinedStyles = (0, _react.useMemo)(function() {
        if (isFocused) return style;
        else if (style) return (0, _objectSpread._)({}, styles, style);
        else return styles;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isFocused
    ]);
    return {
        visuallyHiddenProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, focusWithinProps), {
            style: combinedStyles
        })
    };
}
function VisuallyHidden(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var children = props.children, tmp = props.elementType, Element = tmp === void 0 ? "div" : tmp, isFocusable = props.isFocusable, style = props.style, otherProps = (0, _objectWithoutProperties._)(props, [
        "children",
        "elementType",
        "isFocusable",
        "style"
    ]);
    var visuallyHiddenProps = useVisuallyHidden(props).visuallyHiddenProps;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Element, (0, _utils.mergeProps)(otherProps, visuallyHiddenProps), children);
}

},{"@swc/helpers/_/_object_spread":"96NPP","@swc/helpers/_/_object_spread_props":"1t8Sw","@swc/helpers/_/_object_without_properties":"lgaS6","@swc/helpers/_/_sliced_to_array":"jzEiA","@react-aria/utils":"g2eof","react":"lbBKc","@react-aria/interactions":"1h5DV","@parcel/transformer-js/src/esmodule-helpers.js":"3ieD1"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.74318e68.js.map
